import { Page } from '@/core/architecture'

import { LotteryCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryCompletion Page
 * Implemented as a practical sample.
 */
export const LotteryCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return <LotteryCompletionTemplate state={state} {...actions} />
}
